import { ChangeDetectionStrategy, Component, input } from "@angular/core";
import {
  IOpenAITranscriptMessage,
  IOpenAITranslationMessage,
  ITranscriptMessage,
} from "../../../../core-ui/models/interfaces";

@Component({
  selector: "app-composition-transcript-content",
  templateUrl: "./composition-transcript-content.component.html",
  styleUrls: ["./composition-transcript-content.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CompositionTranscriptContentComponent {
  readonly data = input<ITranscriptMessage[] | IOpenAITranslationMessage[] | IOpenAITranscriptMessage[]>(undefined);

  trackByFn(index, el: IOpenAITranslationMessage) {
    return el.startedAt;
  }

  isNewSender(message: IOpenAITranslationMessage, index: number) {
    if (index === 0) {
      return true;
    }
    const prevMsg = this.data()[index - 1] as IOpenAITranslationMessage;
    return prevMsg.name !== message.name;
  }
}
